(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-styles-links"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.styles-section');
    if (!sections.length) return;
    sections.forEach(function(root){
      var btn = root.querySelector('[data-action="toggle"]');
      if (!btn) return;
      btn.addEventListener('click', function() {
        var expanded = root.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var showText = btn.querySelector('[data-show-text]');
        var hideText = btn.querySelector('[data-hide-text]');
        if (showText && hideText) { showText.hidden = expanded; hideText.hidden = !expanded; }
      }, { passive: true });
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-circles-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SECTION_SELECTOR = '[data-vcg-section]';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const instances = new Map();

  class VideoCirclesGallery {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId;
      this.trackViewport = section.querySelector('.vcg__track-viewport');
      this.triggers = Array.from(section.querySelectorAll('[data-vcg-trigger]'));
      this.thumbVideos = Array.from(section.querySelectorAll('.vcg__thumb-video'));
      this.modal = section.querySelector('[data-vcg-modal]');
      this.player = section.querySelector('[data-vcg-player]');
      this.cta = section.querySelector('[data-vcg-cta]');
      this.sidebar = section.querySelector('[data-vcg-sidebar]');
      this.closeButton = section.querySelector('[data-vcg-close]');
      this.muteButton = section.querySelector('[data-vcg-mute]');
      this.muteLabel = section.querySelector('[data-vcg-mute-label]');
      this.prevButton = section.querySelector('[data-vcg-prev]');
      this.nextButton = section.querySelector('[data-vcg-next]');
      this.backdrop = section.querySelector('[data-vcg-backdrop]');
      this.activeIndex = 0;
      this.lastFocused = null;
      this.isOpen = false;
      this.previewObserver = null;
      this.previewStates = new Map();
      this.destroyed = false;
      this.viewportRaf = null;
      this.boundViewportCheck = this.scheduleViewportCheck.bind(this);
      this.boundHandleKeydown = this.handleKeydown.bind(this);
      this.boundHandleVisibility = this.handleVisibilityChange.bind(this);
      this.boundHandleResize = this.handleResize.bind(this);
      this.boundHandleBlockSelect = this.handleBlockSelect.bind(this);
      this.boundHandleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.isTrackPointerDown = false;
      this.isTrackDragging = false;
      this.trackStartX = 0;
      this.trackStartScrollLeft = 0;
      this.suppressTrackClickUntil = 0;
      this.boundHandleTrackPointerDown = this.handleTrackPointerDown.bind(this);
      this.boundHandleTrackPointerMove = this.handleTrackPointerMove.bind(this);
      this.boundHandleTrackPointerUp = this.handleTrackPointerUp.bind(this);
      this.boundHandleTrackClick = this.handleTrackClick.bind(this);

      if (!this.modal || !this.player || !this.triggers.length) return;

      this.init();
    }

    init() {
      this.bindTriggerEvents();
      this.bindModalEvents();
      this.setupPreviewObserver();
      this.bindTrackViewportEvents();
      this.updateTrackViewportState();
      this.updateControlsState();
      document.addEventListener('visibilitychange', this.boundHandleVisibility);
      window.addEventListener('resize', this.boundHandleResize, { passive: true });
      document.addEventListener('shopify:block:select', this.boundHandleBlockSelect);
      document.addEventListener('shopify:block:deselect', this.boundHandleBlockDeselect);
    }

    bindTriggerEvents() {
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => this.open(index, trigger));
      });
    }

    bindModalEvents() {
      this.closeButton.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      this.prevButton.addEventListener('click', () => this.show(this.activeIndex - 1));
      this.nextButton.addEventListener('click', () => this.show(this.activeIndex + 1));
      this.muteButton.addEventListener('click', () => this.toggleMute());

      this.player.addEventListener('click', () => {
        if (this.player.paused) {
          this.player.play().catch(() => {});
        }
      });

      this.player.addEventListener('volumechange', () => this.syncMuteUi());
      this.player.addEventListener('ended', () => {
        if (this.player.loop) {
          this.player.play().catch(() => {});
        }
      });
    }

    bindTrackViewportEvents() {
      if (!this.trackViewport) return;

      this.trackViewport.addEventListener('pointerdown', this.boundHandleTrackPointerDown);
      this.trackViewport.addEventListener('pointermove', this.boundHandleTrackPointerMove);
      this.trackViewport.addEventListener('pointerup', this.boundHandleTrackPointerUp);
      this.trackViewport.addEventListener('pointercancel', this.boundHandleTrackPointerUp);
      this.trackViewport.addEventListener('lostpointercapture', this.boundHandleTrackPointerUp);
      this.trackViewport.addEventListener('click', this.boundHandleTrackClick, true);
    }

    updateTrackViewportState() {
      if (!this.trackViewport) return;

      const isScrollable = this.trackViewport.scrollWidth > this.trackViewport.clientWidth + 1;
      this.trackViewport.classList.toggle('is-scrollable', isScrollable);

      if (!isScrollable) {
        this.isTrackPointerDown = false;
        this.isTrackDragging = false;
        this.trackViewport.scrollLeft = 0;
        this.trackViewport.classList.remove('is-dragging');
      }
    }

    canDragTrack(event) {
      return Boolean(
        this.trackViewport &&
        window.matchMedia('(min-width: 990px)').matches &&
        this.trackViewport.classList.contains('is-scrollable') &&
        event.pointerType === 'mouse' &&
        event.button === 0
      );
    }

    handleTrackPointerDown(event) {
      if (!this.canDragTrack(event)) return;

      this.isTrackPointerDown = true;
      this.isTrackDragging = false;
      this.trackStartX = event.clientX;
      this.trackStartScrollLeft = this.trackViewport.scrollLeft;

      if (this.trackViewport.setPointerCapture) {
        this.trackViewport.setPointerCapture(event.pointerId);
      }
    }

    handleTrackPointerMove(event) {
      if (!this.isTrackPointerDown || !this.trackViewport) return;

      const deltaX = event.clientX - this.trackStartX;

      if (!this.isTrackDragging && Math.abs(deltaX) > 6) {
        this.isTrackDragging = true;
        this.trackViewport.classList.add('is-dragging');
      }

      if (!this.isTrackDragging) return;

      this.trackViewport.scrollLeft = this.trackStartScrollLeft - deltaX;
      event.preventDefault();
    }

    handleTrackPointerUp(event) {
      if (!this.isTrackPointerDown || !this.trackViewport) return;

      if (this.isTrackDragging) {
        this.suppressTrackClickUntil = window.performance.now() + 250;
      }

      if (
        event.pointerId != null &&
        this.trackViewport.hasPointerCapture &&
        this.trackViewport.hasPointerCapture(event.pointerId)
      ) {
        this.trackViewport.releasePointerCapture(event.pointerId);
      }

      this.isTrackPointerDown = false;
      this.isTrackDragging = false;
      this.trackViewport.classList.remove('is-dragging');
    }

    handleTrackClick(event) {
      if (window.performance.now() < this.suppressTrackClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    setupPreviewObserver() {
      if (prefersReducedMotion) return;
      if (!('IntersectionObserver' in window)) {
        window.addEventListener('scroll', this.boundViewportCheck, { passive: true });
        window.addEventListener('resize', this.boundViewportCheck, { passive: true });
        this.trackViewport?.addEventListener('scroll', this.boundViewportCheck, { passive: true });
        this.scheduleViewportCheck();
        return;
      }
      this.previewObserver = new IntersectionObserver(() => {
        this.resumeThumbs();
      }, { root: null, rootMargin: '0px', threshold: [0, 0.35, 0.65, 1] });
      this.thumbVideos.forEach((video) => this.previewObserver.observe(video));
    }

    scheduleViewportCheck() {
      if (this.viewportRaf || this.destroyed) return;
      this.viewportRaf = requestAnimationFrame(() => {
        this.viewportRaf = null;
        this.resumeThumbs();
      });
    }

    // KDK 2.1: only the chosen preview belongs to a thumbnail. The original
    // remains on the trigger and is consumed exclusively by the modal.
    canPlayPreview(video) {
      return !this.destroyed && !this.isOpen && !document.hidden &&
        !prefersReducedMotion && this.isElementVisible(video);
    }

    loadPreview(video) {
      if (!this.canPlayPreview(video)) return;
      let state = this.previewStates.get(video);
      if (!state) {
        const url = (video.dataset.vcgPreviewSrc || '').trim();
        state = { url, activeUrl: '', status: 'idle', attempts: 0, timer: null, playPending: false };
        this.previewStates.set(video, state);
        if (!url) {
          state.status = 'poster';
          video.dataset.kdkPreviewState = 'poster';
          video.dataset.kdkPreviewError = 'missing-preview-url';
          return;
        }
        state.onError = (event) => this.handlePreviewError(video, state, event);
        state.onReady = () => {
          if (this.destroyed || video.error || video.src !== state.activeUrl ||
              (state.status !== 'loading' && state.status !== 'ready')) return;
          state.status = 'ready';
          video.dataset.kdkPreviewState = 'ready';
          if (this.canPlayPreview(video) && video.paused) this.safePlay(video);
        };
        video.addEventListener('error', state.onError);
        video.addEventListener('loadeddata', state.onReady);
      }
      if (state.status !== 'idle' && state.status !== 'retry-ready') return;
      state.status = 'loading';
      state.attempts += 1;
      video.dataset.kdkPreviewState = 'loading';
      video.dataset.kdkPreviewAttempts = String(state.attempts);
      video.dataset.loaded = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      // No empty <source> nodes in the initial HTML and no source-level
      // error listener: source selection is explicit and occurs only here.
      video.src = state.url;
      state.activeUrl = video.src;
      video.load();
    }

    handlePreviewError(video, state, event) {
      if (this.destroyed || !video.isConnected || event.target !== video ||
          (state.status !== 'loading' && state.status !== 'ready')) return;
      const error = video.error;
      // A generic error event, an aborted load or an autoplay rejection is
      // not evidence that the chosen file is invalid. Never promote to HD.
      if (!error || error.code < 2 || error.code > 4 ||
          !state.activeUrl || video.src !== state.activeUrl) return;

      video.dataset.kdkPreviewError = String(error.code);
      video.dataset.kdkPreviewErrorMessage = error.message || '';
      video.dataset.kdkPreviewFailedSrc = state.activeUrl;
      video.dataset.loaded = 'false';
      if (!video.paused) video.pause();

      if (state.attempts < 2) {
        state.status = 'retry-pending';
        video.dataset.kdkPreviewState = 'retry-pending';
        state.timer = window.setTimeout(() => {
          state.timer = null;
          if (this.destroyed || !video.isConnected) return;
          state.status = 'retry-ready';
          video.dataset.kdkPreviewState = 'retry-ready';
          // A pending retry stays idle while offscreen, in a hidden tab or
          // while the modal is open. Visibility handling will resume it.
          this.resumeThumbs();
        }, 700);
        return;
      }

      // Two genuine failures: show the existing poster instead of silently
      // downloading the multi-megabyte original. Clicking still opens it.
      state.status = 'poster';
      video.dataset.kdkPreviewState = 'poster';
      video.removeAttribute('src');
      video.load();
      console.warn('[KDK video 2.1] Preview failed twice; poster retained.', {
        preview: state.url, code: error.code, message: error.message || ''
      });
    }

    open(index, trigger) {
      this.lastFocused = trigger || document.activeElement;
      this.isOpen = true;
      this.pauseThumbs();
      this.lockBodyScroll();
      this.modal.hidden = false;
      this.modal.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', this.boundHandleKeydown);
      this.show(index, true);
      window.requestAnimationFrame(() => {
        this.closeButton.focus({ preventScroll: true });
      });
    }

    show(index) {
      if (!this.triggers.length) return;

      const total = this.triggers.length;
      this.activeIndex = (index + total) % total;
      const trigger = this.triggers[this.activeIndex];
      const data = trigger.dataset;
      const hasButton = data.hasButton === 'true';

      this.triggers.forEach((item, itemIndex) => {
        item.setAttribute('aria-expanded', itemIndex === this.activeIndex ? 'true' : 'false');
      });

      this.modal.dataset.hasButton = hasButton ? 'true' : 'false';
      this.modal.dataset.single = total < 2 ? 'true' : 'false';

      this.configureCta({
        hasButton,
        label: data.buttonLabel,
        link: data.buttonLink,
        target: data.buttonTarget
      });

      this.loadPlayer({
        url: data.videoUrl,
        type: data.videoType,
        poster: data.poster,
        title: data.title
      });

      this.updateControlsState();
    }

    configureCta({ hasButton, label, link, target }) {
      if (!hasButton || !label || !link) {
        this.cta.hidden = true;
        this.cta.removeAttribute('href');
        this.cta.removeAttribute('target');
        this.cta.removeAttribute('rel');
        this.cta.textContent = '';
        return;
      }

      this.cta.hidden = false;
      this.cta.textContent = label;
      this.cta.href = link;

      if (target === '_blank') {
        this.cta.target = '_blank';
        this.cta.rel = 'noopener noreferrer';
      } else {
        this.cta.target = '_self';
        this.cta.removeAttribute('rel');
      }
    }

    loadPlayer({ url, type, poster, title }) {
      if (!url) return;

      this.player.pause();
      this.player.removeAttribute('src');
      this.player.innerHTML = '';

      const source = document.createElement('source');
      source.src = url;
      if (type) source.type = type;
      this.player.appendChild(source);

      if (poster) {
        this.player.poster = poster;
      } else {
        this.player.removeAttribute('poster');
      }

      this.player.loop = true;
      this.player.muted = true;
      this.player.defaultMuted = true;
      this.player.controls = false;
      this.player.playsInline = true;
      this.player.setAttribute('aria-label', title || 'Vídeo');
      this.player.load();
      this.syncMuteUi();
      this.safePlay(this.player);
    }

    toggleMute() {
      this.player.muted = !this.player.muted;
      this.syncMuteUi();
      this.safePlay(this.player);
    }

    syncMuteUi() {
      const isMuted = this.player.muted;
      const activateLabel = this.section.dataset.labelActivateSound || 'Activar sonido';
      const muteLabel = this.section.dataset.labelMuteSound || 'Quitar sonido';
      const label = isMuted ? activateLabel : muteLabel;

      this.muteButton.classList.toggle('is-muted', isMuted);
      this.muteButton.setAttribute('aria-label', label);
      this.muteButton.setAttribute('aria-pressed', String(!isMuted));
      if (this.muteLabel) {
        this.muteLabel.textContent = label;
      }
    }

    updateControlsState() {
      const total = this.triggers.length;
      this.modal.dataset.single = total < 2 ? 'true' : 'false';
      this.prevButton.disabled = total < 2;
      this.nextButton.disabled = total < 2;
    }

    close() {
      if (!this.isOpen) return;

      this.isOpen = false;
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      this.player.pause();
      this.player.removeAttribute('src');
      this.player.innerHTML = '';
      this.player.load();
      this.player.muted = true;
      this.syncMuteUi();
      this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      document.removeEventListener('keydown', this.boundHandleKeydown);
      this.unlockBodyScroll();
      this.resumeThumbs();

      if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
        this.lastFocused.focus({ preventScroll: true });
      }
    }

    pauseThumbs() {
      this.thumbVideos.forEach((video) => {
        if (!video.paused) video.pause();
      });
    }

    resumeThumbs() {
      if (this.destroyed) return;
      this.thumbVideos.forEach((video) => {
        if (!this.isOpen && !document.hidden && !prefersReducedMotion && this.isElementVisible(video)) {
          this.loadPreview(video);
          if (video.dataset.loaded === 'true' && video.paused) this.safePlay(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    safePlay(video) {
      if (!video) return;
      const state = this.previewStates.get(video);
      if (state && (state.playPending ||
          (state.status !== 'loading' && state.status !== 'ready'))) return;
      const onRejected = (error) => {
        if (!state) return;
        state.playPending = false;
        // Diagnostic only. NotAllowedError/AbortError must not change src.
        if (!this.destroyed) video.dataset.kdkPreviewPlayError = error?.name || 'play-rejected';
      };
      try {
        const promise = video.play();
        if (promise && typeof promise.then === 'function') {
          if (state) state.playPending = true;
          promise.then(() => {
            if (!state) return;
            state.playPending = false;
            delete video.dataset.kdkPreviewPlayError;
            if (!this.canPlayPreview(video) && !video.paused) video.pause();
          }, onRejected);
        }
      } catch (error) {
        onRejected(error);
      }
    }

    handleKeydown(event) {
      if (!this.isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key === 'ArrowRight' && this.triggers.length > 1) {
        event.preventDefault();
        this.show(this.activeIndex + 1);
        return;
      }

      if (event.key === 'ArrowLeft' && this.triggers.length > 1) {
        event.preventDefault();
        this.show(this.activeIndex - 1);
        return;
      }

      if (event.key === 'Tab') {
        this.trapFocus(event);
      }
    }

    trapFocus(event) {
      const focusable = Array.from(
        this.modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((element) => !element.hidden && element.offsetParent !== null);

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.player.pause();
        this.pauseThumbs();
      } else if (this.isOpen) {
        this.safePlay(this.player);
      } else {
        this.resumeThumbs();
      }
    }

    handleResize() {
      this.updateTrackViewportState();

      if (this.isOpen) {
        this.lockBodyScroll();
      }
    }

    handleBlockSelect(event) {
      const block = event.target.closest('[data-vcg-block-id]');
      const section = event.target.closest(SECTION_SELECTOR);

      if (!block || !section || section !== this.section) return;

      const index = this.triggers.findIndex((trigger) => {
        const wrapper = trigger.closest('[data-vcg-block-id]');
        return wrapper && wrapper.dataset.vcgBlockId === block.dataset.vcgBlockId;
      });

      if (index > -1) {
        this.open(index, this.triggers[index]);
      }
    }

    handleBlockDeselect(event) {
      const section = event.target.closest(SECTION_SELECTOR);
      if (section === this.section) {
        this.close();
      }
    }

    isElementVisible(element) {
      if (!element.isConnected) return false;
      const rect = element.getBoundingClientRect();
      const track = this.trackViewport?.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0 || !track) return false;
      const width = Math.max(0, Math.min(rect.right, track.right, window.innerWidth) - Math.max(rect.left, track.left, 0));
      const height = Math.max(0, Math.min(rect.bottom, track.bottom, window.innerHeight) - Math.max(rect.top, track.top, 0));
      return width * height / (rect.width * rect.height) >= 0.35;
    }

    lockBodyScroll() {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.classList.add('vcg-lock');
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    unlockBodyScroll() {
      document.body.classList.remove('vcg-lock');
      document.body.style.paddingRight = '';
    }

    destroy() {
      this.destroyed = true;
      if (this.viewportRaf) cancelAnimationFrame(this.viewportRaf);
      window.removeEventListener('scroll', this.boundViewportCheck);
      window.removeEventListener('resize', this.boundViewportCheck);
      this.trackViewport?.removeEventListener('scroll', this.boundViewportCheck);
      this.close();
      this.pauseThumbs();
      this.previewStates.forEach((state, video) => {
        if (state.timer !== null) window.clearTimeout(state.timer);
        if (state.onError) video.removeEventListener('error', state.onError);
        if (state.onReady) video.removeEventListener('loadeddata', state.onReady);
        if (video.hasAttribute('src')) {
          video.removeAttribute('src');
          video.load();
        }
        video.dataset.loaded = 'false';
      });
      this.previewStates.clear();
      document.removeEventListener('keydown', this.boundHandleKeydown);
      document.removeEventListener('visibilitychange', this.boundHandleVisibility);
      document.removeEventListener('shopify:block:select', this.boundHandleBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.boundHandleBlockDeselect);
      window.removeEventListener('resize', this.boundHandleResize);
      if (this.trackViewport) {
        this.trackViewport.removeEventListener('pointerdown', this.boundHandleTrackPointerDown);
        this.trackViewport.removeEventListener('pointermove', this.boundHandleTrackPointerMove);
        this.trackViewport.removeEventListener('pointerup', this.boundHandleTrackPointerUp);
        this.trackViewport.removeEventListener('pointercancel', this.boundHandleTrackPointerUp);
        this.trackViewport.removeEventListener('lostpointercapture', this.boundHandleTrackPointerUp);
        this.trackViewport.removeEventListener('click', this.boundHandleTrackClick, true);
      }
      if (this.previewObserver) {
        this.previewObserver.disconnect();
      }
      instances.delete(this.sectionId);
      this.section.dataset.vcgInitialized = 'false';
    }
  }

  function initSection(section) {
    if (!section || section.dataset.vcgInitialized === 'true') return;
    section.dataset.vcgInitialized = 'true';
    const instance = new VideoCirclesGallery(section);
    instances.set(section.dataset.sectionId, instance);
  }

  function initAll(root = document) {
    if (root.matches && root.matches(SECTION_SELECTOR)) {
      initSection(root);
    }
    root.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector(SECTION_SELECTOR) || event.target.closest(SECTION_SELECTOR);
    if (!section) return;
    const instance = instances.get(section.dataset.sectionId);
    if (instance) {
      instance.destroy();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
